import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { config } from "../../config";
import { UserContext } from "../../context/UserContext";
import styles from "./Armario.module.css";

function Armario() {
    const { codigoCondominio } = useContext(UserContext);
    const [compartimentos, setCompartimentos] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null); // Controle de qual linha está expandida
    const [errorMessage, setErrorMessage] = useState(""); // Estado para mensagens de erro
    const [showConfirmRetirar, setShowConfirmRetirar] = useState(false); // Controle do modal de confirmação para retirada
    const [selectedCompartimento, setSelectedCompartimento] = useState(null); // Compartimento selecionado para retirada

    const openRetirarModal = (compartimento) => {
        setSelectedCompartimento(compartimento); // Define o compartimento selecionado
        setShowConfirmRetirar(true); // Abre o modal
    };

    const closeRetirarModal = () => {
        setSelectedCompartimento(null); // Limpa o compartimento selecionado
        setShowConfirmRetirar(false); // Fecha o modal
    };


    useEffect(() => {
        if (codigoCondominio) {
            // Buscar dados dos compartimentos do armário
            axios.get(`${config.apiBaseUrl}/Armario/portas/${codigoCondominio}`)
                .then((response) => {
                    console.log("Dados do endpoint /Armario/portas:", response.data); // Log dos dados recebidos
                    const compartimentosRecebidos = response.data;

                    // Buscar encomendas ativas
                    axios.get(`${config.apiBaseUrl}/encomendas/ativas/${codigoCondominio}`)
                        .then((response) => {
                            console.log("Dados do endpoint /encomendas/ativas:", response.data); // Log dos dados recebidos
                            const encomendasAtivas = response.data;

                            // Atualizar o status dos compartimentos
                            const compartimentosAtualizados = compartimentosRecebidos.map((compartimento) => {
                                // Encontra a encomenda ativa associada ao compartimento
                                const encomendaOcupando = encomendasAtivas.find(
                                    (encomenda) => encomenda.nR_FCH === compartimento.nR_ARM
                                );

                                return {
                                    ...compartimento,
                                    sT_ARM: !encomendaOcupando, // Define o status (livre ou ocupado)
                                    dataOcupacao: encomendaOcupando ? encomendaOcupando.dH_GER : null,
                                    iD_DSP: encomendaOcupando ? encomendaOcupando.iD_DSP : compartimento.iD_DSP, // Adiciona iD_DSP ao compartimento
                                    cD_ENC: encomendaOcupando ? encomendaOcupando.cD_ENC : null, // Adiciona cD_ENC ao compartimento
                                    bloco: encomendaOcupando ? encomendaOcupando.bloco : null,
                                    unidade: encomendaOcupando ? encomendaOcupando.nR_CASA : null,
                                };
                            });

                            setCompartimentos(compartimentosAtualizados);
                        })
                        .catch((error) => {
                            console.error("Erro ao buscar encomendas ativas:", error);
                            setErrorMessage("Falha ao carregar encomendas ativas.");
                        });
                })
                .catch((error) => {
                    console.error("Erro ao buscar compartimentos:", error);
                    setErrorMessage("Falha ao carregar os compartimentos do armário.");
                });
        }
    }, [codigoCondominio]);


    const calcularDiasAtivos = (dataOcupacao) => {
        if (!dataOcupacao) return "-"; // Exibe "-" se não houver data registrada

        const dataInicio = new Date(dataOcupacao.split(".")[0]); // Normaliza a data
        if (isNaN(dataInicio)) return "Data inválida";

        const dataAtual = new Date();
        const diffTime = dataAtual - dataInicio; // Diferença em milissegundos
        const diffDays = diffTime / (1000 * 60 * 60 * 24); // Converte para dias (com decimais)

        if (diffDays < 1) {
            return "< 1 dia"; // Para diferenças menores que 1 dia
        }

        return Math.floor(diffDays) + " dia(s)"; // Converte para número inteiro de dias
    };


    // Função para abrir o compartimento
    const abrirCompartimento = (deviceId, relay) => {
        axios.post(`${config.apiBaseUrl}/fechadura/open/${deviceId}/${relay}/1`)
            .then(() => {
                console.log(`Compartimento ${relay} aberto com sucesso no dispositivo ${deviceId}`);
            })
            .catch((error) => {
                console.error(`Erro ao abrir o compartimento ${relay} no dispositivo ${deviceId}:`, error);
            });
    };

    // Função para retirar item do compartimento
    const retirarCompartimento = (deviceId, codigo) => {
        if (!deviceId || !codigo) {
            console.error("Parâmetros inválidos para retirada:", { deviceId, codigo });
            return;
        }

        axios.post(`${config.apiBaseUrl}/fechadura/open/${deviceId}/${codigo}`)
            .then(() => {
                console.log(`Item retirado com sucesso do dispositivo ${deviceId}, código ${codigo}`);
            })
            .catch((error) => {
                console.error(`Erro ao retirar item do dispositivo ${deviceId}, código ${codigo}:`, error);
            });
    };

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1110);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 1110);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <div className={styles.armarioContainer}>
            {/* Mensagem de erro */}
            {errorMessage && (
                <div className={styles.errorMessage}>
                    <p>{errorMessage}</p>
                </div>
            )}

            {/* Legenda */}
            <div className={styles.legendContainer}>
                <h4>Legenda:</h4>
                <div className={styles.legendGrid}>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundOrange}`}></div>
                        <p>Parada há 1 dia</p>
                    </div>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundRed}`}></div>
                        <p>Parada há mais de 1 dia</p>
                    </div>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundGreen}`}></div>
                        <p>Entregue recentemente</p>
                    </div>
                </div>
            </div>

            {/* Tabela Responsiva */}
            <table className={styles.tabelaCompartimentos}>
                {/* Cabeçalho */}
                <thead>
                    <tr>
                        {isSmallScreen ? (
                            <>
                                <th>N°</th>
                                <th>Status</th>
                            </>
                        ) : (
                            <>
                                <th>N°</th>
                                <th>Tamanho</th>
                                <th>Status</th>
                                <th>Tempo Ocupado</th>
                                <th>Ação</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {compartimentos.map((compartimento, index) => {
                        const diasOcupado = calcularDiasAtivos(compartimento.dataOcupacao);

                        return (
                            <>
                                {/* Linha principal */}
                                <tr
                                    key={compartimento.nR_ARM}
                                    onClick={() => isSmallScreen && toggleExpand(index)}
                                    className={isSmallScreen ? styles.rowClickable : ""}
                                >
                                    <td
                                        className={
                                            isSmallScreen
                                                ? diasOcupado.includes("dia(s)")
                                                    ? parseInt(diasOcupado) >= 2
                                                        ? styles.textRed // Para compartimentos com ocupação >= 2 dias
                                                        : styles.textOrange // Para ocupação < 2 dias
                                                    : styles.textGreen // Para ocupação < 1 dia
                                                : ""
                                        }
                                    >
                                        {compartimento.nR_ARM}
                                    </td>
                                    {isSmallScreen ? (
                                        <td className={compartimento.sT_ARM ? styles.livre : styles.ocupado}>
                                            {compartimento.sT_ARM ? "Livre" : "Ocupado"}
                                        </td>
                                    ) : (
                                        <>
                                            <td>{compartimento.tM_ARM || "-"}</td>
                                            <td className={compartimento.sT_ARM ? styles.livre : styles.ocupado}>
                                                {compartimento.sT_ARM ? "Livre" : "Ocupado"}
                                            </td>
                                            <td className={
                                                diasOcupado.includes("dia(s)")
                                                    ? parseInt(diasOcupado) >= 2
                                                        ? styles.textRed
                                                        : styles.textOrange
                                                    : styles.textGreen
                                            }>
                                                {diasOcupado}
                                            </td>
                                            <td>
                                                {compartimento.sT_ARM ? (
                                                    <button
                                                        className={styles.abrirBtn}
                                                        onClick={() =>
                                                            abrirCompartimento(compartimento.iD_DSP, compartimento.nR_ARM)
                                                        }
                                                    >
                                                        Abrir
                                                    </button>
                                                ) : (
                                                    <button
                                                        className={styles.retirarBtn}
                                                        onClick={() => openRetirarModal(compartimento)}
                                                    >
                                                        Retirar
                                                    </button>

                                                )}
                                            </td>
                                        </>
                                    )}
                                </tr>

                                {/* Linha expansível - Apenas para telas pequenas */}
                                {isSmallScreen && expandedIndex === index && (
                                    <tr className={styles.expandedRow}>
                                        <td colSpan="100%">
                                            <div className={styles.expandedContent}>
                                                <div className={styles.infoRow}>
                                                    <p><strong>Tamanho:</strong> {compartimento.tM_ARM || "-"}</p>
                                                    <p className={styles.rightAlign}><strong>Tempo Ocupado:</strong> {diasOcupado}</p>
                                                </div>
                                                <div className={styles.infoRow}>
                                                    <p><strong>Bloco:</strong> {compartimento.bloco || "-"}</p>
                                                    <p className={styles.rightAlign}><strong>Unidade:</strong> {compartimento.unidade || "-"}</p>
                                                </div>
                                                <div className={styles.infoRow}>
                                                    <p className={styles.rightAlign}><strong>Cód da Encomenda:</strong> {compartimento.cD_ENC || "-"}</p>
                                                </div>
                                                <button
                                                    className={compartimento.sT_ARM ? styles.abrirBtn : styles.retirarBtn}
                                                    onClick={() =>
                                                        compartimento.sT_ARM
                                                            ? abrirCompartimento(compartimento.iD_DSP, compartimento.nR_ARM)
                                                            : retirarCompartimento(compartimento.iD_DSP, compartimento.cD_ENC)
                                                    }
                                                >
                                                    {compartimento.sT_ARM ? "Abrir" : "Retirar"}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                            </>
                        );
                    })}
                </tbody>
            </table>
            {showConfirmRetirar && (
                <div className={styles.confirmOverlay}>
                    <div className={styles.confirmModal}>
                        <p>Você tem certeza que deseja retirar o item do compartimento {selectedCompartimento?.nR_ARM}?</p>
                        <div className={styles.confirmModalButtons}>
                            <button
                                className={styles.confirmButton}
                                onClick={() => {
                                    retirarCompartimento(
                                        selectedCompartimento.iD_DSP,
                                        selectedCompartimento.cD_ENC
                                    );
                                    closeRetirarModal(); // Fecha o modal após a confirmação
                                }}
                            >
                                Sim, retirar
                            </button>
                            <button
                                className={styles.cancelButton}
                                onClick={closeRetirarModal}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Armario;
